// extracted by mini-css-extract-plugin
export default {"warningButton":"warning_warningButton__FIhwV"};